<template>
	<div 
		class="u-loader" 
		:class="{ '-small': size === 'small' }"
		aria-hidden="true"
	></div>
</template>

<script setup>
defineProps( {
	size: {
		type: String,
		default: 'normal',
		validator: ( value ) => [ 'normal', 'small' ].includes( value ),
	},
} );
</script>